import { render } from "./ViewCv.vue?vue&type=template&id=bcdca3aa&ts=true"
import script from "./ViewCv.vue?vue&type=script&lang=ts"
export * from "./ViewCv.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__